import {
  SOURCING_EVENT_LIST_SEARCH,
  SOURCING_EVENT_LIST_ALL_STATUS,
  SOURCING_EVENT_LIST_ALL_SEAL_STATUS,
  SOURCING_EVENT_LIST_ALL_AWARD,
  SOURCING_EVENT_LIST_EVENTS,
  SOURCING_EVENT_LIST_ALL_USER,
} from '../constants'

const initialStateSourcingEventList = {
  data: {
    search: '',
    enterSearch: null,
    selectedAllStatus: null,
    selectedSealStatus: null,
    selectedAwardStatus: null,
    selectedAllUser: null,
    status: 0,
    sealStatus: 0,
    allAward: 0,
    allUser: 0,
    eventTypeID: 0,
  },
}

export const setSourcingEventListFilter = (
  state = initialStateSourcingEventList,
  action
) => {
  switch (action.type) {
    case SOURCING_EVENT_LIST_SEARCH: {
      const search = action.search
      const enterSearch = action.enterSearch
      return {
        ...state,
        data: {
          ...state.data,
          search,
          enterSearch,
        },
      }
    }
    case SOURCING_EVENT_LIST_ALL_STATUS: {
      const status = action.status
      const selectedAllStatus = action.selectedAllStatus
      return {
        ...state,
        data: {
          ...state.data,
          status,
          selectedAllStatus,
        },
      }
    }
    case SOURCING_EVENT_LIST_ALL_SEAL_STATUS: {
      const sealStatus = action.sealStatus
      const selectedSealStatus = action.selectedSealStatus
      return {
        ...state,
        data: {
          ...state.data,
          sealStatus,
          selectedSealStatus,
        },
      }
    }
    case SOURCING_EVENT_LIST_ALL_AWARD: {
      const allAward = action.allAward
      const selectedAwardStatus = action.selectedAwardStatus
      return {
        ...state,
        data: {
          ...state.data,
          allAward,
          selectedAwardStatus,
        },
      }
    }
    case SOURCING_EVENT_LIST_ALL_USER: {
      const allUser = action.allUser
      const selectedAllUser = action.selectedAllUser
      return {
        ...state,
        data: {
          ...state.data,
          allUser,
          selectedAllUser,
        },
      }
    }
    case SOURCING_EVENT_LIST_EVENTS: {
      const eventTypeID = action.eventTypeID
      const selectedAllEventType = action.selectedAllEventType
      return {
        ...state,
        data: {
          ...state.data,
          eventTypeID,
          selectedAllEventType,
        },
      }
    }
    default:
      return state
  }
}
